export default "__VITE_ASSET__CAwtgcgl__"